import {Controller} from "stimulus";
import {fetchJson} from "../../assets/request";
import loader from "../../assets/loader"
import {objectToFormData} from "../../assets/forms";

export default class extends Controller {
  static targets = [
    "chargeHighlight",
    "chargeTopoffer",
    "chargeSpecialprice",
    "specialprice",
    "chargeDailyoffer",
    "dailyofferDate"
  ];

  bookHighlight() {
    return this.bookUpselling({
      upselling: "highlight",
      charge: this.chargeHighlightTarget.checked
    });
  }

  bookTopoffer() {
    return this.bookUpselling({
      upselling: "topoffer",
      charge: this.chargeTopofferTarget.checked
    });
  }

  bookSpecialprice() {
    return this.bookUpselling({
      upselling: "specialprice",
      charge: this.chargeSpecialpriceTarget.checked,
      specialprice: this.specialpriceTarget.value
    });
  }

  bookUpselling(data) {
    loader.show();
    data.machine_id = this.machine_id;
    return fetchJson("/machine/edit/book-upselling", {
      method: 'POST',
      body: objectToFormData(data)
    })
      .then(() => {
        window.location.reload();
      }).catch((response) => {
        loader.hide()
        alert(response.responseJSON.message);
      });
  }

  bookDailyoffer() {
    return this.bookUpselling({
      upselling: "dailyoffer",
      day_of_publish: this.dailyofferDateTarget.value || null,
      charge: this.chargeDailyofferTarget.checked
    })
  }

  deleteDailyoffer(event) {
    let row;
    let element = event.target.closest('[data-dailyoffer-id]');
    if (element.dataset.dailyofferId) {
      row = element;
    }

    if (row === void 0) {
      return;
    }
    loader.show();
    return fetchJson("/machine/edit/delete-dailyoffer", {
      method: "POST",
      body: objectToFormData({
        machine_id: this.machine_id,
        id: row.dataset.dailyofferId
      })
    }).then(() => {
      row.parentElement.removeChild(row);
    }).catch((response) => {
      alert(response.responseJSON.message);
    }).then(() => loader.hide());
  }

  get machine_id() {
    return this.element.dataset.machineId;
  }
}
